import { useFeature } from 'src/abTesting';
import { CX_ALERT_BANNER } from 'src/abTesting/features';

export function useShouldShowCXAlertBanner() {
  const { treatment: cxAlertBannerTreatment } = useFeature(CX_ALERT_BANNER);
  return cxAlertBannerTreatment === 'on';
}
